import { Injectable } from "@angular/core";
import { UiKitDialogService } from "@jack-sparrow-libraries/ui-kit";
import { take } from "rxjs";
import { SignConventionAlertModalComponent } from "@featuresAY/mutuelle-web-ay/modals/sign-convention-alert-modal/sign-convention-alert-modal.component";
import { MutuelleAttestationPatient } from "@jack-sparrow-libraries/emotion-models";

@Injectable({
	providedIn: "root",
})
export class MutuelleAlertAyWebService {
	constructor(private dialogService: UiKitDialogService) {}

	async alertDemandeSignatureConvention(mutuelle: MutuelleAttestationPatient, isInterAmc: boolean): Promise<any> {
		const result = await this.dialogService
			.openDialog(SignConventionAlertModalComponent, {
				radius: "lg",
				title: "Signature des conventions",
				inputs: { mutuelle, isInterAmc },
				closeButton: false,
			})
			.afterClosed()
			.pipe(take(1))
			.toPromise();
		return result;
	}
}
